import { mimeTypeLabels } from "../constants/MiscKeys";

export const objectToHtml = (obj, { separator = " : " } = {}) => {
  if (obj === null || typeof obj !== "object" || Array.isArray(obj)) {
    return String(obj);
  }

  const entries = Object.entries(obj);
  if (entries.length === 0) {
    return "";
  }

  const longestKeyLength = entries.reduce(
    (max, [key]) => (key.length > max ? key.length : max),
    0,
  );

  const lines = entries.map(([key, value]) => {
    const paddedKey = key.padEnd(longestKeyLength, " ");
    const stringValue =
      typeof value === "object" && value !== null
        ? JSON.stringify(value)
        : String(value);

    return `
        <div style="font-family: 'Courier New', Courier, monospace; display: block; white-space: pre; letter-spacing: 0; word-spacing: 0;">
            <strong>${paddedKey}${separator}</strong>
            ${stringValue}
        </div>`;
  });

  return `<div style="font-family: 'Courier New', Courier, monospace; white-space: pre-wrap; line-height: 1.2;">${lines.join("")}</div>`;
};

export const getUploadFileTypeHint = (allowedFileTypes) => {
  if (allowedFileTypes?.length) {
    const readableTypes = allowedFileTypes
      .map((t) => mimeTypeLabels[t] || "files")
      .join(", ");
    return `, Only ${readableTypes} allowed`;
  }
  return "";
};